export const publicUrl = (path: string) => {
    const base = process.env.PUBLIC_URL || "";
    return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};
